import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getHistoryAlarmsApi } from '@/api';
import { siteCountyOptions } from '@/utils/options';
import { InfoWindow } from 'vue2-google-maps';

import { mapState, mapActions } from 'vuex';
import { DateTime } from 'luxon';
export default {
  name: 'HistoryAlarms',
  components: {
    InfoWindow: InfoWindow
  },
  data: function data() {
    return {
      siteCountyOptions: siteCountyOptions,
      center: {
        lat: 23.789212,
        lng: 121.468511
      },
      markers: [],
      filterSite: [],
      filterStartTime: '',
      filterEndTime: '',
      recentAlarmsData: [],
      rebuildAlarmsData: [],
      modalData: [],
      modalTitle: '',
      thTitle: [{
        text: '案場',
        value: 'factoryName',
        isSort: true
      }, {
        text: '縣市',
        value: 'county',
        isSort: true
      }, {
        text: '工程師',
        value: 'maintainer',
        isSort: true
      }, {
        text: '設備',
        value: 'which',
        isSort: true
      }, {
        text: '屬性',
        value: 'lastAlarmType',
        isSort: true
      }, {
        text: '開始時間',
        value: 'time',
        isSort: true
      }, {
        text: '影響',
        value: 'allAlarms',
        isSort: true
      }],
      searchInput: '',
      selectValue: {
        name: '案場',
        sortName: 'factoryName',
        isSort: true
      },
      selectedFilter: {
        text: '案場',
        value: 'factoryName',
        isSort: true
      },
      loadingData: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['factoryInfo'])), {}, {
    // filterTitle () {
    //   return this.thTitle.filter(
    //     (x) => x.name !== '影響' && x.text !== '開始時間'
    //   )
    // },
    filterOptions: function filterOptions() {
      return this.thTitle.filter(function (x) {
        return x.name !== '影響' && x.text !== '開始時間';
      }).map(function (item) {
        return {
          text: item.text,
          value: item
        };
      });
    },
    historyFilterSearch: function historyFilterSearch() {
      var _this = this;
      // if (
      //   this.selectValue.name === '開始時間' &&
      //   this.filterStartTime !== '' &&
      //   this.filterEndTime !== ''
      // ) {
      //   if (this.filterSite.length === 0) {
      //     return this.rebuildAlarmsData.filter(
      //       (x) =>
      //         x['time'].slice(-8) >= this.filterStartTime &&
      //         x['time'].slice(-8) <= this.filterEndTime
      //     )
      //   } else {
      //     return this.rebuildAlarmsData.filter(
      //       (x) =>
      //         x['time'].slice(-8) >= this.filterStartTime &&
      //         x['time'].slice(-8) <= this.filterEndTime &&
      //         this.filterSite.includes(x['county'])
      //     )
      //   }
      // }
      if (this.filterSite.length) {
        return this.rebuildAlarmsData.filter(function (resources) {
          return resources["".concat(_this.selectedFilter.value)].match(_this.searchInput) && _this.filterSite.includes(resources['county']);
        });
      }
      return this.rebuildAlarmsData.filter(function (resources) {
        return resources["".concat(_this.selectedFilter.value)].match(_this.searchInput);
      });
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions(['asyncInfo'])), {}, {
    getRecentAlarms: function getRecentAlarms() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _recentAlarms$data;
        var recentAlarms;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loadingData = true;
                _this2.rebuildAlarmsData = [];
                _context.next = 4;
                return getHistoryAlarmsApi();
              case 4:
                recentAlarms = _context.sent;
                if (recentAlarms !== null && recentAlarms !== void 0 && (_recentAlarms$data = recentAlarms.data) !== null && _recentAlarms$data !== void 0 && _recentAlarms$data.success) {
                  _this2.recentAlarmsData = recentAlarms.data.data;
                  _this2.dataBuild();
                }
                _this2.loadingData = false;
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataBuild: function dataBuild() {
      var _this3 = this;
      var array = [];
      var _loop = function _loop(i) {
        var differentArray = [];
        _this3.recentAlarmsData[i].allAlarms.forEach(function (x) {
          differentArray.push({
            inv: x.inv,
            alarmType: x.alarmType
          });
        });
        differentArray = _this3.dedup(differentArray);
        var _loop2 = function _loop2(j) {
          var arr = _this3.recentAlarmsData[i].allAlarms.filter(function (x) {
            return x.inv === differentArray[j].inv && x.alarmType === differentArray[j].alarmType;
          });
          arr.map(function (x) {
            if (x.level === 2) x.alarmType = '發電數據異常';
            // TODO: 無發電數據 -> 發電數據異常，之後要改回來

            // switch (x.level) {
            //   case 2:
            //     x.alarmType = '發電數據異常'
            //     break
            //   case 3:
            //     x.alarmType = '部分通訊異常/裝置斷訊'
            //     break
            //   case 6:
            //     x.alarmType = '系統未連線'
            //     break
            //   case 7:
            //     x.alarmType = '系統短暫斷線'
            //     break
            //   default:
            //     x.alarmType = '-'
            //     break
            // }
          });
          var inv = _this3.invOrNot(differentArray[j].inv);
          array.push({
            which: inv,
            lastAlarmType: arr[arr.length - 1].alarmType,
            lastColorLabel: arr[arr.length - 1].colorLabel,
            time: DateTime.fromISO(arr[arr.length - 1].timestamp).toFormat('yyyy-MM-dd HH:mm:ss'),
            factoryName: _this3.recentAlarmsData[i].factoryName,
            county: _this3.recentAlarmsData[i].county,
            maintainer: _this3.recentAlarmsData[i].maintainer,
            allAlarms: arr
          });
        };
        for (var j = 0; j < differentArray.length; j++) {
          _loop2(j);
        }
      };
      for (var i = 0; i < this.recentAlarmsData.length; i++) {
        _loop(i);
      }
      this.rebuildAlarmsData = array;
      this.sortHistoryData('lastAlarmType', 4);
    },
    // 重複的濾除
    dedup: function dedup(arr) {
      var hashTable = {};
      return arr.filter(function (el) {
        var key = JSON.stringify(el);
        var match = Boolean(hashTable[key]);
        var res = match ? false : hashTable[key] = true;
        return res;
      });
    },
    sortHistoryData: function sortHistoryData(sortType, idx) {
      // if (sortType === 'lastAlarmType') {
      //   let sortData = this.rebuildAlarmsData.map((item) => {
      //     switch (item.lastAlarmType) {
      //       case '系統未連線':
      //         item.sortNo = 1
      //         break
      //       case '系統短暫斷線':
      //         item.sortNo = 2
      //         break
      //       case '發電數據異常':
      //         item.sortNo = 3
      //         break
      //       case '裝置斷訊':
      //         item.sortNo = 5
      //         break
      //       case '部分通訊異常':
      //         item.sortNo = 4
      //         break
      //       default:
      //         item.sortNo = 6
      //         break
      //     }
      //     return item
      //   })
      //   this.rebuildAlarmsData = sortData.sort((a, b) => a.sortNo - b.sortNo)
      // }
      this.rebuildAlarmsData = this.rebuildAlarmsData.sort(function (a, b) {
        if (sortType === 'lastAlarmType') {
          var stringToOrder = function stringToOrder(type) {
            var order = 0;
            switch (type) {
              case '系統未連線':
                order = 1;
                break;
              case '系統短暫斷線':
                order = 2;
                break;
              case '發電數據異常':
                order = 3;
                break;
              case '裝置斷訊':
                order = 4;
                break;
              case '部分通訊異常':
                order = 5;
                break;
              case '發電效率不佳':
                order = 6;
                break;
              default:
                order = 7;
                break;
            }
            return order;
          };
          var aStr = stringToOrder(a[sortType]);
          var bStr = stringToOrder(b[sortType]);
          return aStr - bStr;
        } else {
          return a[sortType] > b[sortType] ? 1 : -1;
        }
      });
      if (!this.thTitle[idx].isSort) {
        this.rebuildAlarmsData = this.rebuildAlarmsData.reverse();
      }
      this.thTitle[idx].isSort = !this.thTitle[idx].isSort;
    },
    levelBgColor: function levelBgColor(color) {
      // const width = 'width: 50px'
      if (color === 'red') {
        return "background-color: rgb(255,139,142);";
      } else if (color === 'orange') {
        return "background-color: orange;";
      } else {
        return "background-color: white;";
      }
    },
    getModalData: function getModalData(arr, factory) {
      this.modalData = arr;
      this.modalTitle = factory;
      this.$bvModal.show('settingModal');
    },
    changeTime: function changeTime(time) {
      return DateTime.fromISO(time).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    invOrNot: function invOrNot(device) {
      var inv = typeof device === 'number' ? 'Inv' + ('0' + device).slice(-2) : device;
      if (device === null) inv = '系統斷線';
      return inv;
    },
    openMap: function openMap(factory) {
      var _this4 = this;
      this.$bvModal.show('mapModal');
      this.center = {};
      setTimeout(function () {
        return _this4.setCenter(factory);
      }, 400);
    },
    setCenter: function setCenter(factory) {
      var whichFactory = this.markers.find(function (x) {
        return x.factoryName === factory;
      });
      this.center = whichFactory.position;
    },
    buildAlarmFactoryLng: function buildAlarmFactoryLng() {
      var _this5 = this;
      this.markers = [];
      var filterAlarmFactory = this.factoryInfo.filter(function (x) {
        return _this5.recentAlarmsData.map(function (y) {
          return y.factoryName;
        }).includes(x.factory);
      }).map(function (x) {
        var thisFactory = _this5.recentAlarmsData.find(function (y) {
          return y.factoryName === x.factory;
        });
        var backgroundColor = _this5.buildMapColor(thisFactory.allAlarms);
        return {
          factoryName: x.factory,
          position: {
            lng: x.informations.longitude,
            lat: x.informations.latitude
          },
          backgroundColor: backgroundColor
        };
      });
      this.markers = filterAlarmFactory;
    },
    buildMapColor: function buildMapColor(arr) {
      var colorLabels = ['red', 'yellow', 'blue', 'orange'];
      var foundColor = arr.find(function (alarm) {
        return colorLabels.includes(alarm.colorLabel);
      });
      return foundColor ? this.levelBgColor(foundColor.colorLabel) : '';
    }
  }),
  created: function created() {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Promise.all([_this6.getRecentAlarms(), _this6.asyncInfo()]);
            case 2:
              _context2.next = 4;
              return _this6.buildAlarmFactoryLng();
            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};